import Card from "./shared/Card"
import TeamContext from "../context/TeamContext"
import {  useContext } from "react"
import Spinner from "./shared/Spinner"



function StatsDisplay() {
    
    // Retrieves data from TeamContext using useContext
    const {receivingStats, rushingStats, passingStats, winStats, conference, division, team, year, loading} = useContext(TeamContext)
    const teamLogo = `static/images/${team}.png`

    const setLoading = () => {
        setTimeout(<Spinner />, 3000)
    }

    // Displays spinner if loading is true
    if(loading) {
        return <Spinner />
    }

    // Displays data based on users input
    return (
        <div className="text-color grid grid-cols-1 justify-center mx-auto px-5 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-5 ">
            <div className=" grid-cols-1 items-center xl:col-span-4 xl:grid-cols-4 lg:col-span-4 lg:grid-cols-4 md:col-span-2 sm:col-span-1">
                <Card>
                    <h1 className="text-4xl text-center pb-4">Team Information</h1>
                    <div className="flex-col text-center content-center justify-around items-center text-2xl inline xl:flex lg:flex-row md:flex-col sm:flex-col sm:content-center">
                        <h1 className="mx-auto md:py-2">Conference: {conference}</h1>
                        <h1 className="mx-auto md:py-2">Division: {division}</h1>
                        <h1 className="mx-auto md:py-2">Team: {team}</h1>
                        {team === 'select-team' || team === "Please Select Team" ? (<img className="logo mx-auto" src='static/images/nfl.png'></img>) : (<img className="logo mx-auto" src={ teamLogo.toLowerCase() }></img>)}
                    </div>
                </Card>
            </div>
            <Card>
                <h1 className="text-4xl pb-4">{year} Record</h1>
                <div className="text-left flex flex-col content-between justify-between">
                    <h3>Wins: {winStats.wins}</h3>
                    <h3>Losses: {winStats.losses}</h3>
                </div>
            </Card>
            <Card>
                <h1 className="text-4xl pb-4">Recieving Stats</h1>
                <div className="text-left">
                    <h3>Receiving Touchdowns: {receivingStats.touchdowns}</h3>
                    <h3>Total Receptions: {receivingStats.receives}</h3>
                    <h3 id="test">Receiving Yards: {receivingStats.yards}</h3>
                </div>
            </Card>
            <Card>
                <h1 className="text-4xl pb-4">Rushing Stats</h1>
                <div className="text-left">
                    <h3>Rushing Touchdowns: {rushingStats.touchdowns}</h3>
                    <h3>Rushing Yards: {rushingStats.yards}</h3>
                </div>
            </Card>
            <Card>
                <h1 className="text-4xl pb-4">Passing Stats</h1>
                <div className="text-left">
                    <h3>Passing Yards: {passingStats.passYards}</h3>
                    <h3>Passing Touchdowns: {passingStats.touchdowns}</h3>
                </div>
            </Card>
        </div>
    )
}

export default StatsDisplay
